import { sendAnalytics } from '@audio-network/analytics'
import { Related } from '@audio-network/componentlibrary/icons'
import { useTranslation } from 'next-i18next'

import { NESTED_TRACKS_TRAY_ID } from '@/components/app/NestedTracks/NestedTracks.constants'
import { useIsNestedTracksEnabled } from '@/components/app/NestedTracks/NestedTracks.hooks'
import { showTrackInNestedTracksTray } from '@/components/app/NestedTracks/NestedTracks.utils'
import { getTrackUrl } from '@/utils/urls'

import { SimilarTracksProps } from './SimilarTracks.types'

const SimilarTracks = ({
	track,
	source,
	...props
}: SimilarTracksProps): JSX.Element => {
	const { t } = useTranslation(['trackrow'])
	const nestedTracksEnabled = useIsNestedTracksEnabled()

	const similarTracksUrl = `${getTrackUrl(track)}?initialTab=similar+tracks`
	const handleSimilarTracksClick = (): void => {
		if (nestedTracksEnabled) {
			showTrackInNestedTracksTray(track, source, 'similar-tracks')
		}
		sendAnalytics({
			noun: 'Similar Tracks',
			pastTenseVerb: 'Clicked',
			eventParameters: {
				TrackId: track.id,
				TrackTitle: track.title,
				AlbumNo: track.album.number,
				TrackSource: source,
				Genre: track.album.genre,
			},
		})
	}

	if (nestedTracksEnabled) {
		return (
			<Related
				title={t('track-actions.similar-tracks')}
				aria-label={t('track-actions.similar-tracks')}
				onClick={handleSimilarTracksClick}
				command="show-modal"
				commandfor={NESTED_TRACKS_TRAY_ID}
				{...props}
			/>
		)
	}

	return (
		<Related
			title={t('track-actions.similar-tracks')}
			onClick={handleSimilarTracksClick}
			href={similarTracksUrl}
			{...props}
		/>
	)
}

export default SimilarTracks
